import { useState } from "react";
import { useUserContext } from "../utils/userContext";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import CreateTransfer from "./Transfers/components/CreateTransfer";
import FromTransfers from "./Transfers/components/FromTransfers";
import ToTransfers from "./Transfers/components/ToTransfers";
import AddInventoryForm from "./Inventory/AddInventoryForm";
import ResetPasswordModal from "../components/Modal/ResetPasswordModal";
import { RiBillLine } from "react-icons/ri";
import { BiTransfer } from "react-icons/bi";
import { MdOutlineArrowOutward } from "react-icons/md";
import OutBillForm from "./Inventory/OutBillForm";
import PermissionGuard from "../components/security/PermissionGuard";

function Dashboard() {
  const { t } = useTranslation("translations");

  const [openAddInventory, setOpenAddInventory] = useState<boolean>(false);
  const [openCreateTransfer, setOpenCreateTransfer] = useState<boolean>(false);
  const [reloadTransfers, setReloadTransfers] = useState<boolean>(false);
  const [openOutBill, setOpenOutBill] = useState<boolean>(false);

  const [resetOpen, setResetOpen] = useState<boolean>(false);

  const { user } = useUserContext();

  useEffect(() => {
    if (user?.isDefaultPassword === true) {
      setResetOpen(true);
    }
  }, []);

  return (
    <>
      <div className="h-auto md:h-[29vh] flex flex-col md:flex-row items-center md:justify-evenly m-4 md:m-10">

        <PermissionGuard permissions={["CreateBillsIn"]}>
          <div
            className="m-2 bg-teal-600 hover:bg-teal-500 w-[350px] text-center rounded-[30px] shadow-md p-8"
            onClick={() => setOpenAddInventory(true)}
          >
            <div className="flex flex-col align-center">
              <div className="mx-auto">
                <RiBillLine size={200} color="white" />
              </div>
              <div className="text-xl font-bold text-white">
                {t('ADD_INVENTORY_MODAL')}
              </div>
            </div>
          </div>
        </PermissionGuard>

        <PermissionGuard permissions={["CreateTransfers"]}>
          <div
            className="m-2 bg-teal-600 hover:bg-teal-500 w-[350px] text-center rounded-[30px] shadow-md p-8"
            onClick={() => setOpenCreateTransfer(true)}
          >
            <div className="flex flex-col align-center">
              <div className="mx-auto">
                <BiTransfer size={200} color="white" />
              </div>
              <div className="text-xl font-bold text-white">
                {t('ADD_TRANSFER_MODAL')}
              </div>
            </div>
          </div>
        </PermissionGuard>

        <PermissionGuard permissions={["CreateBillsOut"]}>
          <div
            className="m-2 bg-teal-600 hover:bg-teal-500 w-[350px] text-center rounded-[30px] shadow-md p-8"
            onClick={() => setOpenOutBill(true)}
          >
            <div className="flex flex-col align-center">
              <div className="mx-auto">
                <MdOutlineArrowOutward size={200} color="white" />
              </div>
              <div className="text-xl font-bold text-white">
                {t('ADD_OUT')}
              </div>
            </div>
          </div>
        </PermissionGuard>

      </div>

      <PermissionGuard permissions={["ViewTransfers"]}>
        <FromTransfers
          reloadFlag={reloadTransfers}
          setReloadFlag={(d) => setReloadTransfers(d)}
        />
      </PermissionGuard>

      <PermissionGuard permissions={["ViewTransfers"]}>
        <ToTransfers
          reloadFlag={reloadTransfers}
          setReloadFlag={(d) => setReloadTransfers(d)}
        />
      </PermissionGuard>

      {/* Modals */}

      {
        openAddInventory &&
        <AddInventoryForm
          open={openAddInventory}
          onClose={() => setOpenAddInventory(false)}
        />
      }

      {
        openCreateTransfer &&
        <CreateTransfer
          open={openCreateTransfer}
          onClose={() => {
            setOpenCreateTransfer(false);
            setReloadTransfers(!reloadTransfers);
          }}
        />
      }

      {
        openOutBill &&
        <OutBillForm
          isOpen={openOutBill}
          onClose={() => setOpenOutBill(false)}
        />
      }

      <ResetPasswordModal
        onClose={() => { setResetOpen(false) }}
        isOpen={resetOpen}
      />
    </>
  )
}

export default Dashboard;
